module.exports = __webpack_public_path__ + "6831b60b13ce173b1f7190ab72bd2f19.pdf";